import { Divider, Group } from '@byecode/ui'
import type { WechatPayConfig } from '@lighthouse/core'
import type { FlowNode, NodeTypes, WeChatPayActionConfig } from '@lighthouse/shared'
import { ListItem4ByecodeUi, OUTPUT_SINGLE_DATA_NODES, OUTPUT_SINGLE_RECORD_NODES, useAtomData } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import { WechatPaymentAccountSelect } from '@/components/WechatPaymentAccountSelect'
import { useFlowContainerContext } from '@/contexts/FlowContext'

import * as CM from '../../styles'
import { SelectRecordControlled } from '../component/SelectRecordControlled'
import Pay from './Pay'

interface WeChatPayActionConfigureProps {
    nodeType?: NodeTypes
    allParentNodes?: FlowNode[]
    allParentActions?: import('@lighthouse/core').IndependentAction[]
    actionTypeSwitcher?: React.ReactNode
    value: WeChatPayActionConfig
    onChange: (value: WeChatPayActionConfig) => void
}

export const WeChatPayActionConfigure: React.FunctionComponent<WeChatPayActionConfigureProps> = ({
    actionTypeSwitcher,
    allParentNodes,
    allParentActions,
    value,
    onChange
}) => {
    const { type } = useFlowContainerContext()
    const isWorkflow = !!type

    const upstreamNodesForVariableSelect = useMemo(
        () => allParentNodes?.filter(item => OUTPUT_SINGLE_DATA_NODES.has(item.data.nodeType)),
        [allParentNodes]
    )
    const upstreamNodesForSource = useMemo(
        () => allParentNodes?.filter(item => OUTPUT_SINGLE_RECORD_NODES.has(item.data.nodeType)),
        [allParentNodes]
    )

    const header = useMemo(() => {
        if (!actionTypeSwitcher) {
            return null
        }
        return (
            <>
                <Group label="动作配置">
                    <ListItem4ByecodeUi>
                        <CM.FormItemLabelWrapper>
                            <CM.FormItemLabel>类型</CM.FormItemLabel>
                        </CM.FormItemLabelWrapper>
                        <CM.FormItemContent>{actionTypeSwitcher}</CM.FormItemContent>
                    </ListItem4ByecodeUi>
                </Group>
                <Divider />
            </>
        )
    }, [actionTypeSwitcher])

    return (
        <CM.Container>
            {header}
            <WechatPaymentAccountSelect
                value={value?.paymentAccountId}
                onChange={paymentAccountId => onChange({ ...value, paymentAccountId })}
                requireEnabled
            />
            <Divider />
            <Group label="选择支付订单">
                <SelectRecordControlled
                    value={value}
                    onChange={val => onChange(val as WechatPayConfig)}
                    upstreamNodesForVariableSelect={upstreamNodesForVariableSelect}
                    upstreamNodesForSource={upstreamNodesForSource}
                    allParentActions={allParentActions}
                    upstreamRecordIsFilterAndSort={false}
                    disableUpstreamRecord={!isWorkflow}
                />
            </Group>
            <Divider color="var(--color-gray-200)" />
            <Pay allParentNodes={allParentNodes} value={value} onChange={onChange} />
        </CM.Container>
    )
}
